import { render, staticRenderFns } from "./moonSampleHome.vue?vue&type=template&id=2bb34a06&scoped=true&"
import script from "./moonSampleHome.vue?vue&type=script&lang=js&"
export * from "./moonSampleHome.vue?vue&type=script&lang=js&"
import style0 from "./moonSampleHome.vue?vue&type=style&index=0&id=2bb34a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb34a06",
  null
  
)

export default component.exports